<template>
  <vs-popup
    class="sign-off-taste-panel-popup"
    title=""
    :active.sync="open"
    :buttons-hidden="true"
    @close="closePopup"
  >
    <vx-card no-shadow class="mb-4">
      <div
        v-if="
          selected_batch &&
          selected_batch.latest_quality_control_batch_sign_off &&
          !isLabStandard
        "
      >
        <h5 class="mb-4 font-semibold">
          {{ batchTitle }}
        </h5>

        <div class="mb-5">
          <small class="label">
            {{ batchLabel }}
          </small>
        </div>

        <div>
          <div class="grid grid-cols-2 gap-x-8 gap-y-4 text-sm">
            <div>
              <div class="text-gray-500 mb-1">
                {{ batchCodeLabel }}
              </div>
              <div class="font-medium">
                {{ batchCode || "-" }}
              </div>
            </div>

            <div>
              <div class="text-gray-500 mb-1">Taste Panel</div>
              <div class="font-medium">
                <HyperLink
                  :id="
                    selected_batch.latest_quality_control_batch_sign_off.group
                      .id
                  "
                  type="tasting-group"
                >
                  {{
                    selected_batch.latest_quality_control_batch_sign_off.group
                      .code
                  }}
                </HyperLink>
              </div>
            </div>

            <div>
              <div class="text-gray-500 mb-1">Signed At</div>
              <div class="font-medium">
                {{
                  selected_batch.latest_quality_control_batch_sign_off
                    .signed_at || "-"
                }}
              </div>
            </div>

            <div>
              <div class="text-gray-500 mb-1">Status</div>
              <div class="font-medium">
                {{
                  selected_batch.latest_quality_control_batch_sign_off.status ||
                  "-"
                }}
              </div>
            </div>

            <div class="col-span-2">
              <div class="text-gray-500 mb-1">Signed By</div>
              <div class="font-medium">
                {{
                  selected_batch.latest_quality_control_batch_sign_off.signed_by
                    .name || "-"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>Lab Standard</p>
      </div>
    </vx-card>
  </vs-popup>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import vSelect from "vue-select";

const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
const ManufacturingRepository = RepositoryFactory.get("manufacturing");

function initialState() {
  return {
    open: false,
    batchType: "",
    selected_batch: null,
    rmWoId: null,
    type: "",
    isLabStandard: false,
  };
}

export default {
  data() {
    return initialState();
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    isRawMaterial() {
      return this.type === "Raw Material Inventory";
    },

    batchTitle() {
      return this.isRawMaterial
        ? "Result for Last Tested Batch"
        : "Result for Last Tested Work Order";
    },

    batchLabel() {
      return this.isRawMaterial ? "RM Batch" : "Work Order";
    },

    batchCodeLabel() {
      return this.isRawMaterial ? "Batch Code" : "Work Order Code";
    },

    selectLabel() {
      return this.isRawMaterial ? "code" : "work_order_code";
    },

    batchCode() {
      if (!this.selected_batch) return "-";

      return this.isRawMaterial
        ? this.selected_batch.code
        : this.selected_batch.work_order_code;
    },
  },
  methods: {
    async openPopup(id, type) {
      try {
        await Object.assign(this.$data, initialState());
        this.type = this.getBatchType(type);
        this.rmWoId = id;
        if (this.rmWoId == "Lab Standard") {
          this.isLabStandard = true;
        } else {
          this.rmWoId = Number(this.rmWoId);
          await this.getLastTestForBatch();
        }
        this.open = true;
      } catch (e) {}
    },

    async getLastTestForBatch() {
      try {
        this.$vs.loading();

        const response = await TriangleTestsRepository.getLastTestForBatch(
          this.rmWoId,
          this.type
        );
        this.selected_batch = response.data.data;
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },
    getBatchType(typeString) {
      var typeMap = {
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\WorkOrder":
          "Work Order",
        "Modules\\TenentCore\\Entities\\Staff\\Manufacture\\RawMaterialStockInventory":
          "Raw Material Inventory",
      };
      return typeMap[typeString];
    },
    closePopup() {
      this.open = false;
    },
  },
};
</script>
<style scoped>
.sign-off-taste-panel-popup >>> .vs-popup {
  min-width: 50% !important;
  z-index: 99999 !important;
}

.sign-off-taste-panel-popup >>> .vs-popup--background {
  z-index: 99998 !important;
}
</style>
